(function(angular) {
    'use strict';

    angular.module('wtUi.services').factory('checkTarget', function() {
        function isBg(event, callback, element) {
            if (!event.target) {
                return;
            }

            const isChild = element.has(event.target).length > 0;
            if (!isChild) {
                /* eslint callback-return:0 */
                callback();
            }
        }

        return {
            isBg: isBg
        };
    });
})(window.angular);
